<template>
  <div class="main">
    <a-row>
      <a-col :span="12">
        <div
          style="width: 100%; height: 100%; display: flex; text-align: center"
        >
          <p style="height:30px;text-align:center;margin">模型分类：</p>
          <a-select
            default-value="所有类型"
            style="width: 120px; margin-right: 40px"
            @change="showModelTypeChange"
          >
            <a-select-option value="所有类型">所有类型</a-select-option>
            <a-select-option
              v-for="t in modelType"
              :key="t.type"
              :value="t.type"
              >{{ t.type }}</a-select-option
            >
          </a-select>
          <p style="height:30px;text-align:center;margin">排序：</p>
          <a-select
            default-value="上传时间-降"
            style="width: 120px"
            @change="sortModel"
          >
            <a-select-option value="上传时间-降">上传时间-降</a-select-option>
            <a-select-option value="上传时间-升">上传时间-升</a-select-option>
          </a-select>
        </div>
      </a-col>
      <a-col :span="12">
        <a-row type="flex" justify="end">
          <a-col :span="12">
            <a-input-search
              placeholder="请输入模型名称"
              enter-button
              @search="onSearch"
            />
          </a-col>
          <a-col :span="4">
            <a-button
              type="primary"
              icon="upload"
              @click="upLoadFileClick"
              v-if="logined"
              >上传模型</a-button
            >
          </a-col>
          <a-col :span="2">
            <a @click="myClick">
              <img
                :src="require('@/assets/my.png')"
                style="height: 36px; width: 36px"
              />
            </a>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <!-- 模型列表 -->
    <div class="flexear">
      <a-empty v-if="toShowModels.length == 0" :description="emptyMessage" />
      <div v-for="m in toShowModels" :key="m.id" class="productList-item">
        <a-card>
          <img
            class="productList-img"
            slot="cover"
            alt="item"
            :src="'./model/show/' + m.coverPath"
            @click="imgClick(m)"
          />
          <template slot="actions">
            <a-tooltip
              placement="top"
              title="修改模型"
              @click="updateModel(m)"
              v-if="logined"
            >
              <a-icon key="edit" type="edit" />
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="删除模型"
              @click="deleteModel(m)"
              v-if="logined"
            >
              <a-icon key="delete" type="delete" />
            </a-tooltip>
          </template>
          <a-card-meta
            class="discrition"
            :title="m.name"
            :description="
              m.remark ? m.remark.replace(/\<br\/>/g, '') : '该模型暂无相关说明'
            "
          ></a-card-meta>
        </a-card>
      </div>
    </div>
    <!-- 修改模型 -->
    <a-drawer
      :title="upload.title"
      :width="500"
      :visible="upload.show"
      :body-style="{ paddingBottom: '50px' }"
      :closable="false"
      :maskClosable="false"
    >
      <a-form-model ref="uploadForm" :model="upload.mod" :rules="upload.rules">
        <a-form-model-item label="模型名称" prop="name">
          <a-input v-model="upload.mod.name" placeholder="请输入模型名称" />
        </a-form-model-item>
        <a-form-model-item label="模型说明">
          <a-input
            v-model="upload.mod.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入模型说明"
          />
        </a-form-model-item>
        <a-form-model-item label="全景地址">
          <a-input
            v-model="upload.mod.vrAddr"
            type="textarea"
            placeholder="请输入全景地址"
          />
        </a-form-model-item>
        <a-form-model-item
          label="模型类型"
          style="display: flex; justify-content: start; margin: 0 auto"
        >
          <a-dropdown :trigger="['click']">
            <a
              class="ant-dropdown-link"
              @click="(e) => e.preventDefault()"
              id="dropdown"
              >{{ selectedType }}<a-icon type="down"
            /></a>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item v-for="t in modelType" :key="t.id">
                {{ t.type }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-form-model-item>
        <a-form-model-item
          label="启用浏览"
          style="display: flex; justify-content: start; margin: 0 auto"
        >
          <a-switch v-model="upload.mod.enableView" />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'center',
          zIndex: 1,
        }"
      >
        <a-button type="primary" @click="uploadSave" style="margin-right: 8px"
          >保存</a-button
        >
        <a-button @click="uploadClose">取消</a-button>
      </div>
    </a-drawer>
    <!-- 登录 -->
    <a-modal
      v-model="loginModel.show"
      title="请登录"
      ok-text="确认"
      cancel-text="取消"
      @ok="login"
      @cancel="hideLoginModal"
    >
      <a-input
        v-model="loginModel.nicName"
        placeholder="请输入用户名"
        type="text"
        style="margin: 5px auto 5px auto"
      />
      <a-input
        v-model="loginModel.password"
        placeholder="请输入用户密码"
        type="password"
      />
    </a-modal>
    <!--我的-->
    <a-drawer
      title="我的"
      placement="right"
      :width="300"
      :visible="loginModel.myIsVisiable"
      @close="onMyClose"
    >
      <div v-if="loginModel.loginFormVisible">
        <a-form-model v-model="loginModel">
          <a-form-model-item label="用户名">
            <a-input
              v-model="loginModel.user.nicName"
              placeholder="请输入用户名"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="密码">
            <a-input
              v-model="loginModel.user.password"
              placeholder="请输入密码"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="login">登录</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div v-if="loginModel.myInfoVisible">
        <div class="myBasic">
          <img
            :src="require('@/assets/my.png')"
            style="width: 56px; height: 56px"
          />
          <div>
            <div style="display: flex; justify-content: center">
              <p style="font-size: 16px; height: 18px">用户名：</p>
              <p style="font-size: 16px; height: 18px">
                {{ loginModel.user.nicName }}
              </p>
            </div>
            <div style="display: flex">
              <p style="font-size: 16px">id：</p>
              <p style="font-size: 16px">{{ loginModel.user.id }}</p>
            </div>
          </div>
        </div>
        <a-divider />
        <div style="display: flex; justify-content: center">
          <p style="font-size: 16px; height: 18px">作品数量：</p>
          <p style="font-size: 16px; height: 18px">
            {{ loginModel.uploadCount }}
          </p>
        </div>
        <a-divider />
        <div style="display: flex; justify-content: center">
          <p style="font-size: 16px; height: 18px">只展示我的作品：</p>
          <a-switch
            v-model="showMyModelsOnly"
            @change="showMyModelOnlyChage"
          ></a-switch>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button type="primary" @click="onMySubmit"> 确定 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { UserManager } from "../../../js/tool/UserManager";
import { Server } from "../../../js/Server/Server";
export default {
  name: "ModelList",
  data() {
    return {
      server: new Server(),
      logined: false,
      isForward: true,
      modelType: [],
      curentType: "所有类型",
      emptyMessage: "暂无数据，请上传模型！",
      search: {
        value: "",
      },
      loginModel: {
        myIsVisiable: false,
        loginFormVisible: false,
        myInfoVisible: true,
        uploadCount: 0,
        user: {
          id: "",
          nicName: "",
          password: "",
        },
      },
      //上传模型相关变量
      selectedType: "请选择类型",
      upload: {
        show: false,
        title: "上传模型",
        status: "update",
        mod: {
          id: "",
          name: "",
          remark: "",
          uploadTime: "",
          path: "",
          coverName: "",
          logoName: "",
          modelName: "",
          modelId: "",
          mapsName: "",
          background_color: "",
          vrAddr: "",
          enableView: true,
          needPassword: false,
          password: "",
          modelType: "",
          userID: "",
        },
        rules: {
          name: [
            { required: true, message: "模型名称不能为空", trigger: "blur" },
          ],
          coverName: [
            { required: true, message: "请上传封面图片", trigger: "change" },
          ],
          logoName: [
            { required: true, message: "请上传logo图片", trigger: "change" },
          ],
          modelName: [
            { required: true, message: "请上传模型文件", trigger: "change" },
          ],
          modelType: [
            { required: true, message: "请选择模型类型", trigger: "change" },
          ],
        },
      },
      showMyModelsOnly: false,
      toShowModels: [],
      allmodels: [],
      publicModels: [],
      mymodels: [],
      tempModels: [],
      searching: false,
      //threejs相关变量
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      color: "",
      userManager: new UserManager(),
    };
  },
  created() {},
  mounted() {
    document.title = "大筑web3d展示平台";
    this.getModelType();
    this.userManager.checkIsLogined(this.checkIsloginedCallBack);
  },
  methods: {
    checkIsloginedCallBack(data) {
      if (data.state == "success") {
        this.logined = true;
        this.loginModel.user = data.data;
        this.loginModel.loginFormVisible = false;
        this.loginModel.myInfoVisible = true;
        this.server.modelByUser(
          this.loginModel.user.id,
          this.getModelByUserCallBack
        );
        this.server.modelNotMineAndPublic(
          this.loginModel.user.id,
          this.getModelNotMineAndPublicCallBack
        );
      } else {
        this.logined = false;
        this.loginModel.loginFormVisible = true;
        this.loginModel.myInfoVisible = false;
        this.server.modelPublic(this.getModelPublicCallback);
      }
    },
    onSearch(val) {
      this.search.value = val;
      if (!this.searching) {
        this.tempModels = this.toShowModels;
      }
      if (this.search.value == "" || this.search.value == null) {
        this.toShowModels = this.tempModels;
        this.searching = false;
      } else {
        this.searching = true;
        var models = [];
        console.log(this.toShowModels);
        this.tempModels.forEach((element) => {
          console.log(element);
          if (
            element.name
              .toUpperCase()
              .indexOf(this.search.value.toUpperCase()) != -1
          ) {
            models.push(element);
          }
        });
        this.toShowModels = models;
        console.log(models);
      }
    },
    getModelType() {
      this.axios.post("./model/getModelType").then((res) => {
        this.modelType = res.data || [];
      });
    },
    list() {
      this.axios.post("./model/list", this.search).then((res) => {
        var ms = res.data || [];
        console.log(ms);
        this.allmodels = this.makeToBoolean(ms);
        this.collectMyModels();
      });
    },
    //暂时使用来校正boolean值
    makeToBoolean(values) {
      var ms = values;
      for (var m of ms) {
        if (m.enableView == "true") {
          m.enableView = true;
        } else {
          m.enableView = false;
        }
        if (m.needPassword == "true") {
          m.needPassword = true;
        } else {
          m.needPassword = false;
        }
      }
      return ms;
    },
    sortModel(value) {
      if (value == "上传时间-升" && this.isForward) {
        this.toShowModels.reverse();
        this.isForward = false;
      } else {
        this.toShowModels.reverse();
        this.isForward = false;
      }
    },
    showModelTypeChange(value) {
      this.curentType = value;
      if (this.showMyModelsOnly) {
        this.getShowModel(this.mymodels);
      } else {
        this.getShowModel(this.allmodels);
      }
    },
    //校验管理密码
    login() {
      if (
        this.loginModel.user.password != "" &&
        this.loginModel.user.nicName != ""
      ) {
        this.axios.post("./user/login", this.loginModel.user).then((res) => {
          this.loginModel.user = res.data;
          console.log(this.loginModel.user);
          if (this.loginModel.user.id) {
            this.$message.success("校验成功！");
            this.loginModel.can = true;
            this.loginModel.show = false;
            this.logined = true;
            this.userManager.setCookie(
              this.loginModel.user.id,
              this.loginModel.user.password,
              30
            );
            this.loginModel.loginFormVisible = false;
            this.loginModel.myInfoVisible = true;
            this.server.modelByUser(
              this.loginModel.user.id,
              this.getModelByUserCallBack
            );
            this.server.modelNotMineAndPublic(
              this.loginModel.user.id,
              this.getModelNotMineAndPublicCallBack
            );
          } else {
            this.$message.error("校验管理密码失败，请重试或联系管理员！");
          }
        });
      } else {
        this.$message.error("请输入管理密码！");
      }
    },
    //点击图片打开模型预览
    imgClick(model) {
      let routeData = this.$router.resolve({
        name: "Model",
        params: { id: model.id },
        query: { id: model.id },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({
      //   name: "Model",
      //   params: { id: model.id },
      //   query: { id: model.id },
      // });
    },
    myClick() {
      this.loginModel.myIsVisiable = true;
      if (this.logined) {
        this.loginModel.loginFormVisible = false;
        this.loginModel.myInfoVisible = true;
      } else {
        this.loginModel.loginFormVisible = true;
        this.loginModel.myInfoVisible = false;
      }
    },
    onMyClose() {
      this.loginModel.myIsVisiable = false;
    },
    onMySubmit() {
      this.loginModel.myIsVisiable = false;
    },

    collectMyModels() {
      this.mymodels = [];
      for (var m of this.allmodels) {
        if (m.userID == this.loginModel.user.id) {
          this.mymodels.push(m);
        }
      }
      this.loginModel.uploadCount = this.mymodels.length;
    },

    //上传时选报模型类型
    handleMenuClick(e) {
      this.selectedType = this.modelType[e.key].type;
      this.upload.mod.modelType = this.selectedType;
    },
    //打开校验密码Modal
    openLoginModal() {
      this.loginModel.show = true;
      this.loginModel.password = "";
    },
    //关闭校验密码Modal
    hideLoginModal() {
      this.loginModel.show = false;
    },
    //打开上传界面
    upLoadFileClick(model) {
      let routeData = this.$router.resolve({
        name: "upLoadFile",
      });
      localStorage.setItem("userID",this.loginModel.user.id);
      window.open(routeData.href, "_blank");
      // this.$router.push({
      //   name: "Model",
      //   params: { id: model.id },
      //   query: { id: model.id },
      // });
    },
    //关闭上传界面
    uploadClose() {
      this.upload.show = false;
    },

    //修改模型
    uploadSave() {
      this.upload.mod.remark = this.upload.mod.remark
        .replace(/\r\n/g, "<br/>")
        .replace(/\n/g, "<br/>");
      this.upload.mod.userID = this.loginModel.user.id;
      if (this.upload.status == "update") {
        this.$refs.uploadForm.validate((valid) => {
          if (valid) {
            this.axios.post("./model/update", this.upload.mod).then((res) => {
              if (res.data != "error") {
                this.$message.success("已成功修改模型");
                this.list();
                this.upload.show = false;
              } else {
                this.$message.error("模型修改失败，请重试或联系管理员！");
              }
            });
          } else {
            return false;
          }
        });
      }
    },
    //修改模型
    updateModel(m) {
      this.upload.show = true;
      this.upload.status = "update";
      this.upload.title = "修改模型";
      this.upload.mod = m;
    },
    //删除模型
    deleteModel(m) {
      let that = this;
      this.$confirm({
        title: "删除确认",
        content: "确定要删除[" + m.name + "]这个模型吗？",
        okText: "确认删除",
        cancelText: "取消",
        onOk() {
          that.axios.post("./model/delete", m).then((res) => {
            if (res.data != "error") {
              that.$message.success("已删除模型");
              that.list();
              that.upload.show = false;
            } else {
              that.$message.error("模型删除失败，请重试或联系管理员！");
            }
          });
        },
        onCancel() {},
      });
    },
    getModelPublicCallback(models) {
      this.allmodels = this.makeToBoolean(models);
      this.toShowModels = this.allmodels;
    },
    getModelByUserCallBack(models) {
      this.mymodels = this.makeToBoolean(models);
      this.allmodels = this.mymodels.concat(this.publicModels);
      if (this.showMyModelsOnly) {
        this.toShowModels = this.mymodels;
      } else {
        this.toShowModels = this.allmodels;
      }
    },
    getModelNotMineAndPublicCallBack(models) {
      this.publicModels = this.makeToBoolean(models);
      this.allmodels = this.mymodels.concat(this.publicModels);
      if (this.showMyModelsOnly) {
        this.toShowModels = this.mymodels;
      } else {
        this.toShowModels = this.allmodels;
      }
    },
    showMyModelOnlyChage(v) {
       if (v) {
         this.getShowModel(this.mymodels);
        } else {
          this.getShowModel(this.allmodels);
        }
    },
    getShowModel(models) {
      console.log(models);
      var newModels = [];
      if (this.curentType == "所有类型") {
        newModels = models;
      } else {
        for (var m of models) {
          if (m.modelType == this.curentType) {
            newModels.push(m);
          }
        }
      }
      this.toShowModels = newModels;
    },
  },
};
</script>

<style scoped>
.main {
  margin: 24px 24px 0px 24px;
}
.flexear {
  display: flex;
  flex-wrap: wrap;
  /* flex-wrap: wrap; */
}
.productList-item {
  width: 200px;
  margin: 10px 10px 10px 10px;
  background: rgb(255, 255, 255);
}
.productList-img {
  width: 180px;
  height: 220px;
  margin: 10px auto;
  object-fit: cover;
}

.discrition {
  height: 40px;
  overflow: visible;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.myBasic {
  display: flex;
  justify-content: space-around;
}
</style>
